module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN324_966885593.b09875fb.png";